import React from "react";

interface InputProps {
  label: string;
  type?: string;
  placeholder?: string;
  error?: string | boolean;
  instructions?: string;
  onChange?: (value: string) => void;
  value?: string;
  name?: string;
  className?: string;
}

export const Input: React.FC<InputProps> = ({
  label,
  type = "text",
  placeholder,
  error,
  instructions,
  onChange,
  value,
  name,
  className = "",
}) => {
  return (
    <div className={`w-full ${className}`}>
      {/* Label */}
      <label
        htmlFor={name}
        className="block text-sm font-medium text-gray-700 mb-1 text-left"
      >
        {label}
      </label>

      {/* Input */}
      <div>
        <input
          id={name}
          name={name}
          type={type}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          placeholder={placeholder}
          className={`w-full border bg-white ${
            error ? "border-red-500" : "border-gray-500"
          } px-3 py-2 rounded shadow-sm focus:outline-none focus:ring-1 ${
            error ? "focus:ring-red-500" : "focus:ring-gray-500"
          }`}
        />
      </div>

      {/* Error Message */}
      {error && <p className="text-sm text-left text-red-500 mt-1">{error}</p>}
      {!error && instructions && (
        <p className="text-sm text-left text-gray-500 mt-1">{instructions}</p>
      )}
    </div>
  );
};
